"use strict";
/**
 * This needs to be handled server side, so its just a place holder.
 * @returns {Function}
 */
function noop() {
    return null;
}
export default function empty() {
    return noop;
}


/** WEBPACK FOOTER **
 ** ./src/validators/empty.js
 **/